import React, { useEffect, useState } from "react"; // Importing React, useEffect, and useState hooks
import axios from "axios"; // Importing axios for making API requests
import { server } from "../index"; // Importing server URL from index.js
import {
  Container,
  Heading,
  HStack,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react"; // Importing Chakra UI components
import Loader from "./Loader"; // Importing Loader component
import ErrorComponent from "./ErrorComponent"; // Importing ErrorComponent component

const Exchanges = () => {
  const [exchanges, setExchanges] = useState([]); // State for storing exchange data
  const [loading, setLoading] = useState(true); // State for loading status
  const [error, setError] = useState(false); // State for error status

  useEffect(() => {
    const fetchExchanges = async () => {
      try {
        const { data } = await axios.get(`${server}/exchanges`); // Fetch data from API
        setExchanges(data); // Set exchange data
        setLoading(false); // Set loading to false
      } catch (error) {
        setError(true); // Set error status
        setLoading(false); // Set loading to false
      }
    };
    fetchExchanges();
  }, []); // Empty dependency array means this effect runs once after the initial render

  if (error)
    return <ErrorComponent message={"Error While Fetching Exchanges"} />;

  return (
    // Use the Container component from Chakra UI to center the content
    <Container maxW={"container.xl"}>
      {loading ? (
        <Loader /> // Show loader while data is being fetched
      ) : (
        <>
        {/* Show a heading and a list of ExchangeCard components */}
          <HStack wrap={"wrap"} justifyContent={"space-evenly"}>
            {exchanges.map((i) => (
              <ExchangeCard
                key={i.id}
                name={i.name}
                img={i.image}
                rank={i.trust_score_rank}
                url={i.url}
              />
            ))}
          </HStack>
        </>
      )}
    </Container>
  );
};

// Function to generate a random color

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
// ExchangeCard component to display exchange data
const ExchangeCard = ({ name, img, rank, url }) => {
  const bgColor = getRandomColor(); // Generate a random background color

  // Return a link to the exchange website with exchange data
  return (
    <a href={url} target={"_blank"} rel="noopener noreferrer">
      <VStack
        w={"52"}
        h={"52"}
        bg={bgColor}
        shadow={"lg"}
        p={"8"}
        borderRadius={"full"}
        transition={"all 0.3s"}
        m={"4"}
        css={{
          "&:hover": {
            transform: "scale(1.1)", // Scale up card on hover
          },
        }}
      >
        <Image
          src={img}
          w={"20"}
          h={"20"}
          objectFit={"contain"}
          alt={"Exchange"}
        />
        <Heading size={"md"} noOfLines={1}>
          {rank}
        </Heading>

        <Text noOfLines={1}>{name}</Text>
      </VStack>
    </a>
  );
};

export default Exchanges;
// This component fetches exchange data from the API and displays it in ExchangeCard components. 
// Each ExchangeCard displays the exchange name, trust score rank, and logo. 
// The ExchangeCard component also generates a random background color for each card.